import ButtonClear from "./ButtonClear";
import { COLORS, SIZES } from "./utilities";

export { COLORS, SIZES };
export default ButtonClear;
